<template>
  <div class="coursePlans-list">
    <table-list
      title="资源列表"
      :loading="loading"
      :data="courseList"
      :search-form="searchForm(this)"
      :columns="columns(this)"
      :pager="pager"
      :btns="btns(this)"
      :options="{ selection: true }"
      @search="onSearch"
      @selectionChange="handleSelectionChange"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    ></table-list>
  </div>
</template>
<script>
// 顶部按钮
const btns = _this => [
  {
    label: '确定添加课程',
    method: _this.handleaddCourse,
  },
]
// 搜索框配置
const searchForm = () => [
  {
    label: '课程名称',
    prop: 'keyword',
  },
  {
    label: '课程类型',
    type: 'select',
    prop: 'courseType',
    children: [
      { value: 0, label: '录播' },
      { value: 1, label: '直播' },
    ],
  },
  {
    label: '课程状态',
    type: 'select',
    prop: 'enable',
    children: [
      { value: 0, label: '禁用' },
      { value: 1, label: '启用' },
    ],
  },
  {
    label: '上传时间',
    type: 'picker',
    prop: 'createTime',
  },
]
// 表格列配置
const columns = () => [
  {
    prop: 'courseId',
    label: '课程编号',
  },
  {
    prop: 'mobile',
    label: '课程封面',
    render: (h, { row }) => {
      return [
        row.pic
          ? h('img', {
              domProps: { src: row.pic },
              style: 'height: 50px',
            })
          : null,
      ]
    },
  },
  {
    prop: 'courseName',
    label: '课程名称',
  },
  {
    prop: 'courseType',
    label: '课程类型',
    formatter: row => {
      return { 0: '录播', 1: '直播', 9: '未知' }[row.courseType]
    },
  },
  {
    prop: 'courseTeacherNames',
    label: '任课老师',
  },
  {
    prop: 'chapterCount',
    label: '章节数',
  },
  {
    prop: 'durationCount',
    label: '课程时长',
  },
  {
    prop: 'createTime',
    label: '创建时间',
  },
]
import TableList from '@/components/TableList'
import to from 'await-to'
import { Courseoptional } from '@/api/course'
import { addOwnCourse } from '@/api/class'
export default {
  name: 'CoursePlans',
  components: {
    TableList,
  },
  data() {
    return {
      btns,
      searchForm,
      columns,
      loading: false,
      courseList: [],
      selectCourse: [],
      pager: {
        total: 0,
        size: 10,
        current: 1,
      },
      classId: this.$route.query.classId,
    }
  },
  mounted() {
    this.getCourse()
  },
  methods: {
    async getCourse(queryParams = {}) {
      if (this.loading) return
      const { current, size } = this.pager
      this.loading = true
      const [res, err] = await to(
        Courseoptional({ classId: this.classId, current, size, ...queryParams }),
      )
      this.loading = false
      if (err) return this.$message.warning(err.msg)
      this.courseList = res.data.list
      this.pager.total = res.data.total
    },
    async handleaddCourse() {
      if (!this.selectCourse.length) return this.$message.warning('请先选择要添加的课程')
      let CourseIds = []
      this.selectCourse.map(item => CourseIds.push(item.courseId))
      if (this.loading) return
      this.loading = true
      const [, err] = await to(addOwnCourse({ classId: this.classId, courses: CourseIds }))
      this.loading = false
      if (err) return this.$message.warning(err.msg)
      this.$router.push({
        path: '/course/classManger/courseAdd',
        query: { classId: this.classId },
      })
    },
    // 查询按钮
    onSearch(queryParams) {
      this.pager.current = 1
      if (queryParams.createTime) {
        queryParams.startTime = queryParams.createTime[0]
        queryParams.endTime = queryParams.createTime[1]
      } else {
        queryParams.startTime = ''
        queryParams.endTime = ''
      }
      this.getCourse(queryParams)
    },
    // 多选
    handleSelectionChange(val) {
      this.selectCourse = val
    },
    // 分页
    handleSizeChange(size) {
      this.pager.current = 1
      this.pager.size = size
      this.getCourse()
    },
    handleCurrentChange(current) {
      this.pager.current = current
      this.getCourse()
    },
  },
}
</script>
